import React, { useState } from 'react'

import { BorderedDiv } from 'elements/layout/BorderedDiv'
import { Cell } from 'elements/layout/Cell'
import { Div } from 'elements/layout/Div'
import { Row } from 'elements/layout/Row'
import { Span } from 'elements/layout/Span'
import { Icon } from 'elements/media/Icon'
import { Link } from 'elements/text/Link'
import { Text } from 'elements/text/Text'

import { ICON } from 'config/icons'

import type { TGuideMenuDesktopProps } from './GuideMenuDesktop'

type TGuideMenuMobileProps = TGuideMenuDesktopProps

export const GuideMenuMobile: TFC<TGuideMenuMobileProps> = ({ titles }) => {
  const [isExpanded, setExpanded] = useState(false)

  return (
    <>
      {' '}
      <BorderedDiv
        borderRadius="4px"
        borderColor="blue"
        p="0 10px"
        onClick={() => setExpanded(!isExpanded)}
        id="Summary__button"
      >
        <Row align="middleLeft">
          <Cell flex="1" align="middleBetween">
            <Text color="darkBlue" fontSize="1em" lineHeight="2.5em">
              trans:guide:word.menu
            </Text>
            <Span right>
              <Icon name={isExpanded ? ICON.CHEVRON_UP : ICON.CHEVRON_DOWN} m="0 0 0 10px" color="blue" />
            </Span>
          </Cell>
        </Row>
      </BorderedDiv>
      <Div h={isExpanded ? 'auto' : '0px'} noOverflow={!isExpanded} m="1em 0 0" p="0 10px" id="Summary__content">
        {titles.map((title, i) => (
          <Link key={i} to={`#${title.id}`}>
            <Div align="left" m="0 0 20px">
              <Text color="darkBlue" fontSize="1em">
                {title.textContent}
              </Text>
            </Div>
          </Link>
        ))}
      </Div>
    </>
  )
}
